import { render, staticRenderFns } from "./InsuranceInfo.vue?vue&type=template&id=0ebc7fc2&scoped=true&"
import script from "./InsuranceInfo.vue?vue&type=script&lang=js&"
export * from "./InsuranceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebc7fc2",
  null
  
)

export default component.exports